import React from 'react';
import {
  AFFILIATE_MEMBERSHIP,
  PUBLIC_ACCESS,
  REGULAR_MEMBERSHIP,
} from '../home/homePageConstants';
import './MembershipOptionsTiers.css';

export const MembershipOptionsTiers: React.FC = () => (
  <section className="membership-options-tiers" aria-labelledby="membership-options-tiers-heading">
    <h3 id="membership-options-tiers-heading" className="membership-options-tiers__title">
      Membership Options
    </h3>
    <div className="membership-options-tiers__grid">
      <article className="membership-options-tiers__column membership-options-tiers__column--public">
        <p className="membership-options-tiers__tier">{PUBLIC_ACCESS.tierLabel}</p>
        <h4 className="membership-options-tiers__heading">{PUBLIC_ACCESS.heading}</h4>
        <p className="membership-options-tiers__intro">{PUBLIC_ACCESS.description}</p>
        <ul className="membership-options-tiers__list">
          {PUBLIC_ACCESS.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>

      <article className="membership-options-tiers__column membership-options-tiers__column--affiliate">
        <p className="membership-options-tiers__tier">{AFFILIATE_MEMBERSHIP.tierLabel}</p>
        <h4 className="membership-options-tiers__heading membership-options-tiers__heading--emphasis">
          {AFFILIATE_MEMBERSHIP.heading}
        </h4>
        <p className="membership-options-tiers__price">{AFFILIATE_MEMBERSHIP.priceLabel}</p>
        <p className="membership-options-tiers__intro">{AFFILIATE_MEMBERSHIP.intro}</p>
        <ul className="membership-options-tiers__list">
          {AFFILIATE_MEMBERSHIP.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>

      <article className="membership-options-tiers__column membership-options-tiers__column--regular">
        <p className="membership-options-tiers__tier">{REGULAR_MEMBERSHIP.tierLabel}</p>
        <h4 className="membership-options-tiers__heading membership-options-tiers__heading--emphasis">
          {REGULAR_MEMBERSHIP.heading}
        </h4>
        <p className="membership-options-tiers__price">{REGULAR_MEMBERSHIP.priceLabel}</p>
        <p className="membership-options-tiers__intro">{REGULAR_MEMBERSHIP.intro}</p>
        <ul className="membership-options-tiers__list">
          {REGULAR_MEMBERSHIP.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>
    </div>
  </section>
);

export default MembershipOptionsTiers;
